export const SKILL_MODEL = "skill";

const skillModel = {
  skills: [],
  name: "",
  category: "",
  level: ""
};

export default skillModel;
